/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonSearchHandlerInfo = {
    ID: NexonSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace NexonSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        TOKEN = 'TOKEN',
        NFT = 'NFT',
    }


}

